import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useAsyncAction } from '../../commonComponents/Hooks';
import Loading from '../../commonComponents/Loading';
import { sendNewLinkToReferee } from '../../core/api';
import RefereePageLayout from '../layouts/RefereePageLayout';
import SecondaryButton from './buttons/SecondaryButton';
import MessageBox from './MessageBox';

const RefereeExpiryPage = ({ expiredRefereeToken }: Props) => {
	const location = useLocation();
	const [loading, errorMessage, performAsyncAction] = useAsyncAction();
	const [requestSent, setRequestSent] = React.useState(false);

	const handleSendNewLinkClick = async () => {
		await performAsyncAction(async () => {
			await sendNewLinkToReferee(expiredRefereeToken, location.pathname);
			setRequestSent(true);
		});
	};

	if (loading) {
		return <Loading />;
	}

	return (
		<RefereePageLayout title="Expired">
			{requestSent && <MessageBox successMessage="Email sent." />}
			{errorMessage && <MessageBox error={errorMessage} />}
			<h1>Oops!</h1>
			<p>This link has expired. Please send a new link to your email.</p>
			<SecondaryButton text="Send" onClick={handleSendNewLinkClick} />
		</RefereePageLayout>
	);
};

interface Props {
	expiredRefereeToken: string;
}

export default RefereeExpiryPage;
